import FormHeader from "@/components/FormHeader";
import Modal from "@/components/Modal";
import Navbar from "@/components/Navbar";
import { TracingBeam } from "@/components/ui/tracing-beam";
// import { formatDateIndonesia } from "@/lib/utils"
// import { getLinimasa } from "@/services/getData"
import { useState } from "react";
// import { useQuery } from "@tanstack/react-query"
import ScrollToTop from "@/components/ScrollToTop";
import Announcement from "./partial/Announcement";
import DaftarUnduhan from "./partial/DaftarUnduhan";
import Footer from "./partial/Footer";
import Informasi from "./partial/Informasi";
import JalurSeleksi from "./partial/JalurSeleksi";
import ListProdi from "./partial/ListProdi";
import Upcoming from "./partial/Upcoming";

export default function LandingPage() {
  const [showListProdi, setShowListProdi] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  // const { data: linimasa } = useQuery({
  //   queryKey: ["linimasa"],
  //   queryFn: getLinimasa,
  // })

  // const linimasaSNBP = linimasa?.["SNBP"]?.length ? linimasa["SNBP"][0] : null

  return (
    <div>
      <title>SPMB Undiksha - Sistem Penerimaan Mahasiswa Baru</title>
      <meta
        name="description"
        content="Sistem Penerimaan Mahasiswa Baru (SPMB) Universitas Pendidikan Ganesha. Daftar online, cek informasi pendaftaran, jadwal seleksi, dan hasil ujian masuk."
      />
      <meta name="author" content="UPA TIK Undiksha" />
      <link rel="author" href="https://undiksha.ac.id" />

      <meta
        name="keywords"
        content="SPMB Undiksha, Pendaftaran Mahasiswa Baru, Universitas Pendidikan Ganesha, Seleksi Masuk, Pendaftaran Online, SPMB, Undiksha Singaraja, Jalur Mandiri, Jalur SNBT, Jalur SNBP"
      />

      <meta
        property="og:title"
        content="SPMB Undiksha - Sistem Penerimaan Mahasiswa Baru"
      />
      <meta
        property="og:description"
        content="Daftar online dan ikuti seleksi penerimaan mahasiswa baru di Universitas Pendidikan Ganesha."
      />

      {/* <AnnouncementBanner /> */}
      <br />
      <Navbar />
      <div>
        <Announcement />

        <section className="mb-0 flex justify-center items-center container mx-auto lg:px-20 px-4">
          {/* <div className="lg:mt-10 mt-10 relative w-full overflow-hidden bg-white dark:bg-slate-900 dark:text-white flex flex-col rounded-xl shadow-sm dark:border dark:border-slate-800">
            <div className="absolute inset-0 w-full h-full bg-white/90 dark:bg-slate-900/90 z-20 [mask-image:radial-gradient(transparent,white)] pointer-events-none" /> */}
          {/* <Boxes /> */}

          {/* <div className="relative z-40 text-center">
              <motion.h1
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 0.5 }}
                className="mb-10 lg:text-7xl text-4xl font-bold"
              >
                {web.titleFull}{" "}
                <span className="text-primary">{web.univAcronym}</span>
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: "-50%" }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.3 }}
                className="mb-10 lg:text-2xl text-xl text-muted-foreground"
              >
                Portal registrasi dan pendaftaran kembali mahasiswa baru{" "}
                {web.univ}
              </motion.p>
              <div className="flex justify-center gap-3">
                <Button onClick={() => setShowListProdi((show) => !show)}>
                  Kenali Program Studi
                </Button>
              </div>
            </div> */}
          {/* <HeroSection /> */}
          {/* <RunningText /> */}
          {/* <br /> */}
          {/* <div className="relative mb-10 z-40 mx-3"> */}

          <section className="grid lg:grid-cols-2 gap-5">
            {/* <div className="w-full max-w-4xl mx-auto">
                  <Card className="relative overflow-hidden border-0 shadow-2xl bg-gradient-to-br from-blue-50 via-white to-indigo-50">
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-blue-100 to-transparent rounded-full -translate-y-16 translate-x-16 opacity-60" />
                    <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-indigo-100 to-transparent rounded-full translate-y-12 -translate-x-12 opacity-60" />

                    <CardHeader className="pb-4">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0">
                          <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-pink-600 rounded-2xl flex items-center justify-center shadow-lg">
                            <Megaphone className="w-6 h-6 text-white" />
                          </div>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <Badge
                              variant="secondary"
                              className="bg-blue-100 text-blue-700 hover:bg-blue-100"
                            >
                              <Sparkles className="w-3 h-3 mr-1" />
                              Pengumuman Penting
                            </Badge>
                          </div>
                          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 leading-tight">
                            Selamat kepada peserta yang telah lulus SNBT di{" "}
                            {web.univAcronym}!
                          </h1>

                          <p className="text-gray-600 mt-2 font-medium">SNBT</p>
                        </div>
                        <div className="flex-shrink-0">
                          <FaRegFaceGrinStars className="w-8 h-8 text-yellow-500" />
                        </div>
                      </div>
                    </CardHeader>

                    <CardContent className="space-y-6">
                      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-100">
                        <div className="flex items-center gap-3 mb-4">
                          <CalendarDays className="w-5 h-5 text-blue-600" />
                          <span className="font-semibold text-blue-900">
                            Jadwal Pendaftaran Kembali
                          </span>
                        </div>
                        <p className="text-gray-700 leading-relaxed">
                          Pendaftaran ulang dapat dilakukan mulai{" "}
                          <span className="font-bold text-blue-700 bg-blue-100 px-2 py-1 rounded">
                            29 Mei 2025 pukul 16.00 WITA.
                          </span>{" "}
                          Bagi peserta yang lulus melalui jalur SNBT, tidak
                          perlu melakukan Register. Silakan login menggunakan
                          email SNPMB pusat dan lakukan permintaan pengaturan
                          ulang password. Permintaan pengaturan ulang password
                          dapat dilakukan mulai{" "}
                          <span className="font-bold text-blue-700 bg-blue-100 px-2 py-1 rounded">
                            29 Mei 2025 pukul 16.00 WITA.
                          </span>{" "}
                        </p>
                      </div>

                      <div className="space-y-4">
                        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6">
                          <h3 className="font-semibold text-amber-900 mb-3">
                            📝 Informasi Pendaftaran Kembali
                          </h3>
                          <p className="text-gray-700 leading-relaxed">
                            <span>
                              Untuk login pertama kali, mohon lakukan{" "}
                              <span className="text-primary font-semibold">
                                <Link to={"/forgot-password"}>
                                  permintaan password
                                </Link>
                              </span>{" "}
                              menggunakan email yang terdaftar di SNPMB Pusat.{" "}
                            </span>
                            <span className="font-semibold text-amber-800">
                              Setelah mendapatkan password, Anda dapat
                              menggunakannya untuk proses daftar kembali.
                            </span>
                          </p>
                        </div>

                        <div className="bg-green-50 border border-green-200 rounded-2xl p-6">
                          <h3 className="font-semibold text-green-900 mb-3">
                            📚 Panduan Pendaftaran Kembali
                          </h3>
                          <p className="text-gray-700">
                            Silahkan{" "}
                            <a
                              href="/panduan/Panduan_Pendaftaran_Kembali_SNBT_2025.pdf"
                              target="_blank"
                              className="inline-flex items-center gap-1 text-green-700 hover:text-green-800 font-medium underline decoration-2 underline-offset-2"
                              rel="noreferrer"
                            >
                              unduh panduan pendaftaran kembali SNBT
                              <ExternalLink className="w-3 h-3" />
                            </a>{" "}
                            dan siapkan persyaratan serta berkas yang
                            dibutuhkan.
                          </p>
                        </div>
                      </div>

                      <Separator className="my-6" />

                      <div className="space-y-4">
                        <h3 className="font-semibold text-gray-900">
                          Mulai Sekarang
                        </h3>
                        <div className="flex lg:flex-row flex-col gap-3">
                          <Button
                            className="flex-1 bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700 shadow-lg hover:shadow-xl transition-all duration-200"
                            onClick={() => navigate("/forgot-password")}
                          >
                            <span className="mr-2">🚀</span>
                            Permintaan/Lupa Password
                          </Button>
                          <Button
                            variant="outline"
                            className="flex-1 border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all duration-200"
                            onClick={() => navigate("/login")}
                          >
                            <span className="mr-2">🔑</span>
                            Sudah mendapatkan password/Login
                          </Button>
                        </div>
                      </div>

                      <div className="bg-gray-50 rounded-2xl p-4 border border-gray-200">
                        <p className="text-sm text-gray-600 text-center">
                          💡 <span className="font-medium">Tips:</span> Pastikan
                          semua dokumen persyaratan sudah disiapkan sebelum
                          melakukan pendaftaran kembali
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </div> */}

            {/* <div className="w-full max-w-4xl mx-auto">
                  <Card className="relative overflow-hidden border-0 shadow-2xl bg-gradient-to-br from-blue-50 via-white to-indigo-50">
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-blue-100 to-transparent rounded-full -translate-y-16 translate-x-16 opacity-60" />
                    <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-indigo-100 to-transparent rounded-full translate-y-12 -translate-x-12 opacity-60" />

                    <CardHeader className="pb-4">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0">
                          <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-pink-600 rounded-2xl flex items-center justify-center shadow-lg">
                            <Megaphone className="w-6 h-6 text-white" />
                          </div>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <Badge
                              variant="secondary"
                              className="bg-blue-100 text-blue-700 hover:bg-blue-100"
                            >
                              <Sparkles className="w-3 h-3 mr-1" />
                              Pengumuman Penting
                            </Badge>
                          </div>
                          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 leading-tight">
                            Informasi kelulusan SMBJM CBT {web.univAcronym}!
                          </h1>

                          <p className="text-gray-600 mt-2 font-medium">
                            SMBJM CBT
                          </p>
                        </div>
                        <div className="flex-shrink-0">
                          <FaRegFaceGrinStars className="w-8 h-8 text-yellow-500" />
                        </div>
                      </div>
                    </CardHeader>

                    <CardContent className="space-y-6">
                      <div className="space-y-4">
                        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6">
                          <h3 className="font-semibold text-amber-900 mb-3">
                            📝 Pengumuman
                          </h3>
                          <p className="text-gray-700 leading-relaxed">
                            Untuk informasi pengumuman kelulusan SMBJM-CBT dapat
                            dilihat pada jumat, 20 Juni 2025 Pukul 16.00 Wita,
                            dengan login pada sistem
                          </p>
                        </div>
                      </div>

                      <Separator className="my-6" />

                      <div className="space-y-4">
                        <div className="flex lg:flex-row flex-col gap-3">
                          <Button
                            variant="outline"
                            className="flex-1 border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all duration-200"
                            onClick={() => navigate("/login")}
                          >
                            <span className="mr-2">🔑</span>
                            Login Disini
                          </Button>
                        </div>
                      </div>

                      <div className="bg-gray-50 rounded-2xl p-4 border border-gray-200">
                        <p className="text-sm text-gray-600 text-center">
                          💡 <span className="font-medium">Tips:</span> Pastikan
                          anda menggunakan akun yang digunakan untuk mendaftar
                          SMBJM CBT
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </div> */}
            {/* <div className="w-full max-w-4xl mx-auto">
                  <Card className="relative overflow-hidden border-0 shadow-2xl bg-gradient-to-br from-blue-50 via-white to-indigo-50">
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-blue-100 to-transparent rounded-full -translate-y-16 translate-x-16 opacity-60" />
                    <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-indigo-100 to-transparent rounded-full translate-y-12 -translate-x-12 opacity-60" />

                    <CardHeader className="pb-4">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0">
                          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center shadow-lg">
                            <Megaphone className="w-6 h-6 text-white" />
                          </div>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <Badge
                              variant="secondary"
                              className="bg-blue-100 text-blue-700 hover:bg-blue-100"
                            >
                              <Sparkles className="w-3 h-3 mr-1" />
                              Pengumuman Penting
                            </Badge>
                          </div>
                          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 leading-tight">
                            Pendaftaran Jalur Mandiri Telah Dibuka!
                          </h1>
                          <p className="text-gray-600 mt-2 font-medium">
                            SMBJM Nilai Raport • SMBJM Talent Scouting
                          </p>
                        </div>
                        <div className="flex-shrink-0">
                          <Smile className="w-8 h-8 text-yellow-500" />
                        </div>
                      </div>
                    </CardHeader>

                    <CardContent className="space-y-6">
                      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-100">
                        <div className="flex items-center gap-3 mb-4">
                          <CalendarDays className="w-5 h-5 text-blue-600" />
                          <span className="font-semibold text-blue-900">
                            Jadwal Pendaftaran
                          </span>
                        </div>
                        <p className="text-gray-700 leading-relaxed">
                          Anda dapat melakukan pendaftaran mulai{" "}
                          <span className="font-bold text-blue-700 bg-blue-100 px-2 py-1 rounded">
                            2 April 2025 pukul 16.00 WITA hingga 27 Juni 2025
                            pukul 23.00 Wita
                          </span>
                        </p>
                      </div>

                      <div className="space-y-4">
                        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6">
                          <h3 className="font-semibold text-amber-900 mb-3">
                            📝 Informasi Registrasi
                          </h3>
                          <p className="text-gray-700 leading-relaxed">
                            Bagi yang belum memiliki akun, Anda bisa melakukan
                            registrasi akun terlebih dahulu.{" "}
                            <span className="font-semibold text-amber-800">
                              Anda dapat mulai mendaftarkan akun dari sekarang
                              untuk digunakan dalam pendaftaran jalur yang
                              dipilih.
                            </span>
                          </p>
                        </div>

                        <div className="bg-green-50 border border-green-200 rounded-2xl p-6">
                          <h3 className="font-semibold text-green-900 mb-3">
                            📚 Panduan Pendaftaran
                          </h3>
                          <p className="text-gray-700">
                            Silahkan{" "}
                            <a
                              href={web.linkPedomanSMBJM}
                              target="_blank"
                              className="inline-flex items-center gap-1 text-green-700 hover:text-green-800 font-medium underline decoration-2 underline-offset-2"
                              rel="noreferrer"
                            >
                              unduh panduan pendaftaran SMBJM
                              <ExternalLink className="w-3 h-3" />
                            </a>{" "}
                            dan siapkan persyaratan serta berkas yang
                            dibutuhkan.
                          </p>
                        </div>
                      </div>

                      <Separator className="my-6" />

                      <div className="space-y-4">
                        <h3 className="font-semibold text-gray-900">
                          Mulai Sekarang
                        </h3>
                        <div className="flex lg:flex-row flex-col gap-3">
                          <Button
                            className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 shadow-lg hover:shadow-xl transition-all duration-200"
                            onClick={() => navigate("/registrasi")}
                          >
                            <span className="mr-2">🚀</span>
                            Registrasi Akun Baru
                          </Button>
                          <Button
                            variant="outline"
                            className="flex-1 border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all duration-200"
                            onClick={() => navigate("/login")}
                          >
                            <span className="mr-2">🔑</span>
                            Sudah Memiliki Akun / Login
                          </Button>
                        </div>
                      </div>

                      <div className="bg-gray-50 rounded-2xl p-4 border border-gray-200">
                        <p className="text-sm text-gray-600 text-center">
                          💡 <span className="font-medium">Tips:</span> Pastikan
                          semua dokumen persyaratan sudah disiapkan sebelum
                          melakukan pendaftaran
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </div> */}
            {/* INFO PENUTUPAN SMBJM RAPORT DAN TALENT */}
            {/* <div className="w-full max-w-4xl mx-auto">
                  <Card className="relative overflow-hidden border-0 shadow-2xl bg-gradient-to-br from-blue-50 via-white to-indigo-50">
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-blue-100 to-transparent rounded-full -translate-y-16 translate-x-16 opacity-60" />
                    <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-indigo-100 to-transparent rounded-full translate-y-12 -translate-x-12 opacity-60" />

                    <CardHeader className="pb-4">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0">
                          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center shadow-lg">
                            <Megaphone className="w-6 h-6 text-white" />
                          </div>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <Badge
                              variant="secondary"
                              className="bg-blue-100 text-blue-700 hover:bg-blue-100"
                            >
                              <Sparkles className="w-3 h-3 mr-1" />
                              Pengumuman Penting
                            </Badge>
                          </div>
                          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 leading-tight">
                            Pendaftaran Jalur SMBJM Nilai Raport dan Talent
                            Scouting telah ditutup
                          </h1>
                          <p className="text-gray-600 mt-2 font-medium">
                            Terima kasih atas partisipasi Anda dalam proses
                            seleksi.
                          </p>
                        </div>
                        <div className="flex-shrink-0">
                          <Smile className="w-8 h-8 text-yellow-500" />
                        </div>
                      </div>
                    </CardHeader>

                    <CardContent className="space-y-6">
                      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-100">
                        <div className="flex items-center gap-3 mb-4">
                          <CalendarDays className="w-5 h-5 text-blue-600" />
                          <span className="font-semibold text-blue-900">
                            Pengumuman Kelulusan
                          </span>
                        </div>
                        <p className="text-gray-700 leading-relaxed">
                          Hasil seleksi jalur mandiri akan diumumkan pada{" "}
                          <span className="font-bold text-blue-700 bg-blue-100 px-2 py-1 rounded">
                            11 Juli 2025
                          </span>
                          . Untuk melihat hasil kelulusan, silakan login ke
                          dalam sistem menggunakan akun yang telah Anda
                          daftarkan.
                        </p>
                      </div>

                      <Separator className="my-6" />

                      <div className="space-y-4">
                        <h3 className="font-semibold text-gray-900">
                          Akses Pengumuman Kelulusan
                        </h3>
                        <div className="flex lg:flex-row flex-col gap-3">
                          <Button
                            variant="outline"
                            className="flex-1 border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all duration-200"
                            onClick={() => navigate("/login")}
                          >
                            <span className="mr-2">🔑</span>
                            Login Disini
                          </Button>
                        </div>
                      </div>

                      <div className="bg-gray-50 rounded-2xl p-4 border border-gray-200">
                        <p className="text-sm text-gray-600 text-center">
                          💡 <span className="font-medium">Catatan:</span>{" "}
                          Pastikan Anda login dengan akun yang benar untuk
                          melihat hasil seleksi. Jika lupa kata sandi, gunakan
                          fitur pemulihan akun yang tersedia.
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </div> */}
            {/* END INFO PENUTUPAN SMBJM RAPORT DAN TALENT */}

            {/* 
                <div className="w-full max-w-4xl mx-auto">
                  <Card className="relative overflow-hidden border-0 shadow-2xl bg-gradient-to-br from-blue-50 via-white to-indigo-50">
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-blue-100 to-transparent rounded-full -translate-y-16 translate-x-16 opacity-60" />
                    <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-indigo-100 to-transparent rounded-full translate-y-12 -translate-x-12 opacity-60" />

                    <CardHeader className="pb-4">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0">
                          <div className="w-12 h-12 bg-gradient-to-br from-purple-300 to-violet-600 rounded-2xl flex items-center justify-center shadow-lg">
                            <Megaphone className="w-6 h-6 text-white" />
                          </div>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <Badge
                              variant="secondary"
                              className="bg-blue-100 text-blue-700 hover:bg-blue-100"
                            >
                              <Sparkles className="w-3 h-3 mr-1" />
                              Pengumuman Penting
                            </Badge>
                          </div>
                          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 leading-tight">
                            Selamat kepada peserta yang telah lulus SMBJM NILAI
                            RAPORT dan SMBJM TALENTSCOUTING di {web.univAcronym}
                            !
                          </h1>

                          <p className="text-gray-600 mt-2 font-medium">
                            SMBJM NILAI RAPORT dan SMBJM TALENTSCOUTING
                          </p>
                        </div>
                        <div className="flex-shrink-0">
                          <FaRegFaceGrinStars className="w-8 h-8 text-yellow-500" />
                        </div>
                      </div>
                    </CardHeader>

                    <CardContent className="space-y-6">
                      <div className="space-y-4">
                        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6">
                          <h3 className="font-semibold text-amber-900 mb-3">
                            📝 Informasi Pengumuman
                          </h3>
                          <p className="text-gray-700 leading-relaxed">
                            Silahkan login ke sistem untuk melihat pengumuman
                            kelulusan jalur SMBJM NILAI RAPORT dan SMBJM
                            TALENTSCOUTING
                          </p>
                        </div>
                      </div>

                      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-100">
                        <div className="flex items-center gap-3 mb-4">
                          <CalendarDays className="w-5 h-5 text-blue-600" />
                          <span className="font-semibold text-blue-900">
                            Jadwal Pendaftaran Kembali
                          </span>
                        </div>
                        <p className="text-gray-700 leading-relaxed">
                          Pendaftaran ulang dapat dilakukan mulai{" "}
                          <span className="font-bold text-blue-700 bg-blue-100 px-2 py-1 rounded">
                            11 Juli 2025
                          </span>{" "}
                          hingga
                          <span className="font-bold text-blue-700 bg-blue-100 px-2 py-1 rounded">
                            31 Juli 2025
                          </span>{" "}
                          Bagi peserta yang lulus melalui jalur SMBJM NILAI
                          RAPORT dan SMBJM TALENTSCOUTING, silahkan melakukan
                          login ke sistem melalui tombol dibawah.{" "}
                        </p>
                      </div>

                      <div className="bg-green-50 border border-green-200 rounded-2xl p-6">
                        <h3 className="font-semibold text-green-900 mb-3">
                          📚 Panduan Pendaftaran Kembali
                        </h3>
                        <p className="text-gray-700">
                          Silahkan{" "}
                          <a
                            href="/panduan/Panduan-Pendaftaran-Kembali-Jalur Mandiri-Raport-Talent.pdf"
                            target="_blank"
                            className="inline-flex items-center gap-1 text-green-700 hover:text-green-800 font-medium underline decoration-2 underline-offset-2"
                            rel="noreferrer"
                          >
                            unduh panduan pendaftaran kembali SMBJM NILAI RAPORT
                            dan SMBJM TALENTSCOUTING
                            <ExternalLink className="w-3 h-3" />
                          </a>{" "}
                          dan siapkan persyaratan serta berkas yang dibutuhkan.
                        </p>
                      </div>

                      <Separator className="my-6" />

                      <div className="space-y-4">
                        <h3 className="font-semibold text-gray-900">
                          Mulai Sekarang
                        </h3>
                        <div className="flex lg:flex-row flex-col gap-3">
                          <Button
                            variant="outline"
                            className="flex-1 border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all duration-200"
                            onClick={() => navigate("/login")}
                          >
                            <span className="mr-2">🔑</span>
                            Login Disini
                          </Button>
                        </div>
                      </div>

                      <div className="bg-gray-50 rounded-2xl p-4 border border-gray-200">
                        <p className="text-sm text-gray-600 text-center">
                          💡 <span className="font-medium">Tips:</span> Pastikan
                          semua dokumen persyaratan sudah disiapkan sebelum
                          melakukan pendaftaran kembali
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </div> */}

            {/* <div className="w-full max-w-4xl mx-auto">
                  <Card className="relative overflow-hidden border-0 shadow-2xl bg-gradient-to-br from-blue-50 via-white to-indigo-50">
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-blue-100 to-transparent rounded-full -translate-y-16 translate-x-16 opacity-60" />
                    <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-indigo-100 to-transparent rounded-full translate-y-12 -translate-x-12 opacity-60" />

                    <CardHeader className="pb-4">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0">
                          <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-pink-600 rounded-2xl flex items-center justify-center shadow-lg">
                            <Megaphone className="w-6 h-6 text-white" />
                          </div>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <Badge
                              variant="secondary"
                              className="bg-blue-100 text-blue-700 hover:bg-blue-100"
                            >
                              <Sparkles className="w-3 h-3 mr-1" />
                              Pengumuman Penting
                            </Badge>
                          </div>
                          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 leading-tight">
                            Selamat kepada peserta yang telah lulus SMBJM CBT di{" "}
                            {web.univAcronym}!
                          </h1>

                          <p className="text-gray-600 mt-2 font-medium">
                            SMBJM CBT
                          </p>
                        </div>
                        <div className="flex-shrink-0">
                          <FaRegFaceGrinStars className="w-8 h-8 text-yellow-500" />
                        </div>
                      </div>
                    </CardHeader>

                    <CardContent className="space-y-6">
                      <div className="space-y-4">
                        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6">
                          <h3 className="font-semibold text-amber-900 mb-3">
                            📝 Informasi Pengumuman
                          </h3>
                          <p className="text-gray-700 leading-relaxed">
                            Silahkan login ke sistem untuk melihat pengumuman
                            kelulusan jalur SMBJM CBT
                          </p>
                        </div>
                      </div>

                      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-100">
                        <div className="flex items-center gap-3 mb-4">
                          <CalendarDays className="w-5 h-5 text-blue-600" />
                          <span className="font-semibold text-blue-900">
                            Jadwal Pendaftaran Kembali
                          </span>
                        </div>
                        <p className="text-gray-700 leading-relaxed">
                          Pendaftaran ulang dapat dilakukan mulai{" "}
                          <span className="font-bold text-blue-700 bg-blue-100 px-2 py-1 rounded">
                            20 Juni 2025
                          </span>{" "}
                          hingga
                          <span className="font-bold text-blue-700 bg-blue-100 px-2 py-1 rounded">
                            9 Juli 2025
                          </span>{" "}
                          Bagi peserta yang lulus melalui jalur SMBJM CBT,
                          silahkan melakukan login ke sistem melalui tombol
                          dibawah.{" "}
                        </p>
                      </div>

                      <div className="bg-green-50 border border-green-200 rounded-2xl p-6">
                        <h3 className="font-semibold text-green-900 mb-3">
                          📚 Panduan Pendaftaran Kembali
                        </h3>
                        <p className="text-gray-700">
                          Silahkan{" "}
                          <a
                            href="/panduan/Panduan-Pendaftaran-Kembali-Jalur Mandiri-CBT.pdf"
                            target="_blank"
                            className="inline-flex items-center gap-1 text-green-700 hover:text-green-800 font-medium underline decoration-2 underline-offset-2"
                            rel="noreferrer"
                          >
                            unduh panduan pendaftaran kembali SMBJM CBT
                            <ExternalLink className="w-3 h-3" />
                          </a>{" "}
                          dan siapkan persyaratan serta berkas yang dibutuhkan.
                        </p>
                      </div>

                      <Separator className="my-6" />

                      <div className="space-y-4">
                        <h3 className="font-semibold text-gray-900">
                          Mulai Sekarang
                        </h3>
                        <div className="flex lg:flex-row flex-col gap-3">
                          <Button
                            variant="outline"
                            className="flex-1 border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all duration-200"
                            onClick={() => navigate("/login")}
                          >
                            <span className="mr-2">🔑</span>
                            Login Disini
                          </Button>
                        </div>
                      </div>

                      <div className="bg-gray-50 rounded-2xl p-4 border border-gray-200">
                        <p className="text-sm text-gray-600 text-center">
                          💡 <span className="font-medium">Tips:</span> Pastikan
                          semua dokumen persyaratan sudah disiapkan sebelum
                          melakukan pendaftaran kembali
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </div> */}
          </section>
          {/* </div> */}
          <div className="relative mb-10 z-40 mx-3"></div>
          {/* </div> */}
        </section>

        {/* <div className="relative z-40 w-full max-w-5xl mx-auto space-y-12 py-8 px-4">
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl blur opacity-20 dark:opacity-40 group-hover:opacity-40 dark:group-hover:opacity-60 transition duration-1000 group-hover:duration-200" />

            <div className="relative bg-white dark:bg-slate-900 ring-1 ring-gray-200 dark:ring-slate-800 rounded-xl p-6 sm:p-10 flex flex-col md:flex-row items-center justify-between gap-6 shadow-sm">
              <div className="space-y-2 text-center md:text-left">
                <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  Tertarik bergabung bersama kami?
                </h2>
                <p className="text-gray-500 dark:text-gray-400 text-base max-w-xl">
                  Dapatkan informasi lengkap mengenai jadwal, jalur seleksi, dan
                  persyaratan Penerimaan Mahasiswa Baru tahun ini.
                </p>
              </div>

              <div className="flex-shrink-0">
                <Button
                  size="lg"
                  className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-500 text-white shadow-md transition-all group-hover:translate-x-1"
                  asChild
                >
                  <Link to={web.linkPMB} target="_blank">
                    Informasi PMB
                    <ArrowRight className="ml-2 w-4 h-4" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

          {web.showAkreditasi && (
            <div className="flex justify-center">
              <Card className="border-none shadow-none bg-slate-50/50 dark:bg-slate-900/50 max-w-4xl w-full rounded-xl">
                <CardContent className="p-6 md:p-8">
                  <div className="flex flex-col md:flex-row items-center gap-8">
                    <div className="flex-shrink-0 relative group">
                      <div className="absolute inset-0 bg-blue-100 dark:bg-blue-900/30 rounded-xl transform rotate-3 transition-transform group-hover:rotate-6" />

                      <img
                        src={ImgAkreditasi}
                        alt="Logo Akreditasi Unggul BAN-PT"
                        className="relative w-48 md:w-64 h-auto object-contain bg-white rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 p-2"
                      />
                    </div>

                    <div className="text-center md:text-left space-y-3 flex-1">
                      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-100/50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 text-sm font-medium mb-1">
                        <Award className="w-4 h-4" />
                        Pengakuan Nasional
                      </div>

                      <h3 className="text-xl md:text-2xl font-bold text-slate-900 dark:text-white">
                        Terakreditasi{" "}
                        <span className="text-blue-600 dark:text-blue-400">
                          Unggul
                        </span>
                      </h3>

                      <p className="text-slate-600 dark:text-slate-400 leading-relaxed text-base">
                        Institusi kami telah diakui oleh{" "}
                        <span className="font-semibold text-slate-800 dark:text-slate-200">
                          Badan Akreditasi Nasional Perguruan Tinggi (BAN-PT)
                        </span>
                        . Kami berkomitmen penuh untuk mendidik mahasiswa dalam
                        bidang kependidikan dan non-kependidikan dengan standar
                        kualitas terbaik.
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          )}
        </div> */}

        <TracingBeam>
          <JalurSeleksi />
          <Informasi />
          <Upcoming />
          <DaftarUnduhan />
        </TracingBeam>

        <ScrollToTop />
      </div>
      <Modal
        show={showListProdi}
        onClose={() => setShowListProdi(false)}
        width="2xl"
      >
        <ListProdi />
      </Modal>
      <Footer />
      <Modal show={showWarning} onClose={() => setShowWarning(false)}>
        <div>
          <FormHeader
            title="Pendaftaran Ulang SNBP Masih Ditutup"
            icon={<></>}
            description="Kami akan buka resmi pada Kamis, 20 Maret 2025. Jangan sampai terlewat!"
          />
        </div>
      </Modal>
    </div>
  );
}
